import { Injectable } from '@angular/core';
import { AesEncryptionHelperService } from '../aesEncryptionHelper/aes-encryption-helper.service';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StorageHelperService {
  private storageSubject = new BehaviorSubject<string | null>(null);

  constructor(private aesEncryptionHelperService: AesEncryptionHelperService) { }

  notifyStorageChange(): void {
    this.storageSubject.next('storageChanged');
  }

  watchStorage(): Observable<string | null> {
    return this.storageSubject.asObservable();
  }

  getData(sessionName: string): any {
    sessionStorage.getItem(sessionName);
  }

  getDecryptData(sessionName: string): any {
    return this.aesEncryptionHelperService.decryptText(sessionStorage.getItem(sessionName)) || 'null';
  }

  private storeData(sessionName: string, sessionData: any): void {
    sessionStorage.setItem(sessionName, sessionData);
    this.notifyStorageChange();
  }

  storeEncryptedData(sessionName: string, sessionData: any): void {
    const sessionDataEncrypt = this.aesEncryptionHelperService.encryptText(sessionData);
    this.storeData(sessionName, sessionDataEncrypt);
  }

  removeItem(sessionItemName: string): void {
    sessionStorage.removeItem(sessionItemName);
  }

  clearSession(): void {
    sessionStorage.clear();
  }
}
